import React from 'react'
import styled from 'styled-components'
import { useLocalLabels } from '@sentecacommerce-theme/lib'
import { ProductPageLabels } from '../../productPage.props'
import { Typography } from '../../../Common'
// import { ProductRating } from './ProductRating'

export const ReviewTabHeader = ({ numberOfReviews }: any) => {
  const labels = useLocalLabels<ProductPageLabels>()
  return (
    <ReviewHeader>
      {`${labels?.commentsAndRating} (${numberOfReviews})`}
      {/* <ProductRating value={stars} /> */}
    </ReviewHeader>
  )
}

const ReviewHeader = styled(Typography).attrs({
  as: 'h5',
  variant: 6,
})`
  color: inherit;
  display: flex;
  font-weight: inherit;
  line-height: 1.8;
`
